import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import classes from "./PieChart.module.css";
import ChartCard from "./ChartCard";
import ChartCardTitle from "./ChartCardTitle";
ChartJS.register(ArcElement, Tooltip, Legend);

// below is dummy data what pie chart accepts
// export const data1 = {
//   labels: [],
//   datasets: [
//     {
//       label: [],
//       data: [],
//       backgroundColor: [
//         "rgba(255, 99, 132, 0.8)",
//         "rgba(54, 162, 235, 0.8)",
//         "rgba(255, 206, 86, 0.8)",
//         "rgba(75, 192, 192, 0.8)",
//         "rgba(22, 172, 74, 1)",
//         "rgba(255, 159, 64, 1)",
//       ],
//       borderColor: [
//         "rgba(255, 99, 132, 1)",
//         "rgba(54, 162, 235, 1)",
//         "rgba(255, 206, 86, 1)",
//         "rgba(75, 192, 192, 1)",
//         "rgba(22, 172, 74, 1)",
//         "rgba(255, 159, 64, 1)",
//       ],
//       borderWidth: 1,
//     },
//   ],
// };

/*
 this PieChart component takes the data converted by genPieChartData 
 and creates specific object which fulfills conditions laid by chartJS library ie
 how charJS librarry want us to give our data to their component.
 */

// parent component = ChartDisplayArea
export function PieChart1({ data1 }) {
  //  FORMAT of Data1 received
  /**
   
          const dummydata = [
        {questionTitle:"How was the food",
         dataForBranch : [
            {
                branchName:"GK",
                options :[
                    {optionTitle:"Excellent",count : 5},
                    {optionTitle:"Good",count : 5},
                    {optionTitle:"okay",count : 5},
                    {optionTitle:"poor",count : 5},
                ]

            }
         ]
        }
    ]
        
        
]
     */

  // Format of OUTPUT WE RETURN

  /**
  const output  = [
    {
        qTitle:"How was the food",
        branchData :[
                {
                    branchName:"GK",
                    data :{
                        label:[],
                        datasets :[
                            {
                                labels:[],
                                data:[2,6,5,4],
                                backgroundColor:[],
                                borderColor:[],
                                borderWidth:1
                            }
                        ]
                    }

                }
        ]
    }
 ]
 */

  const superPieChartDataArray = [];

  const readyPieData = data1?.map((data) => {
    let objForEachQuestion = {
      qtitle: data.questionTitle,
      branchData: [],
    };
    let arrForOneBranch = data.dataForBranch.map((brData) => {
      let objForEachBranch = {
        branchName: brData.branchName,
        data: {},
      };

      let countData = [];
      brData.options.options.forEach((optionNcountObj) => {
        countData.push(optionNcountObj.count);
      });

      let data = {
        label: [],
        datasets: [
          {
            label: [], // this is left empty
            data: [...countData],
            backgroundColor: [
              "rgba(79, 60, 220, 1)",
              "rgba(71, 208, 119 )",
              "rgba(255, 206, 86 )",
              "rgba(231, 81, 114, 1)",
              "rgba(224, 20, 64 )",
              "rgba(255, 159, 64 )",
              "rgba(75, 192, 192, 0.8)",
            ],
            borderColor: [
              "rgba(79, 60, 220, 1)",
              "rgba(71, 208, 119, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(231, 81, 114, 1)",
              "rgba(224, 20, 64, 1)",
              "rgba(255, 159, 64, 1)",
              "rgba(75, 192, 192, 1)",
            ],
            borderWidth: 1,
          },
        ],
      };
      objForEachBranch.data = { ...data };

      return objForEachBranch;
    });
    objForEachQuestion.branchData = [...arrForOneBranch];

    return objForEachQuestion;
  });

  return (
    <div className={classes.container}>
      {readyPieData.map((d1, superIndex) => {
        let question = d1.qtitle;

        return (
          <ChartCardTitle title={question} key={superIndex}>
            {d1.branchData.map((bdata, bIndex) => {
              let branchName = bdata.branchName;
              return (
                <ChartCard
                  key={`${branchName} ${superIndex}`}
                  id={superIndex}
                  bName={branchName}
                  title={question}
                  data={data1[superIndex].dataForBranch[bIndex].options}
                >
                  <Pie data={bdata.data} />
                </ChartCard>
              );
            })}
          </ChartCardTitle>
        );
      })}
    </div>
  );
}
